<template>
	<PopupRouterView :showLeftIcon="true" label="Scheduler Configuration Input"  entityName="schedulerconfiguration" :documentId="mainRecordId"  @saveMethod="saveActionConfirmation" @hideMethod="onHidden">
		<b-card>
			<b-col cols="12" lg="6">
				<app-input-combobox-autocomplete :options="schedulerCronIntervals" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Interval Type" id="input-" size="sm" :model.sync="model.intervalTypeId"  :selected="model.intervalType != null ? model.intervalType.name : ''" @input="getSchedulerCronIntervals" />
				<app-input-textbox id="fieldset-interval-value" label-cols-sm="4" label-cols-lg="3" label="Interval Value" label-for="input-interval-value" size="sm" :model.sync="model.intervalValue"   />
				<app-input-textbox id="fieldset-interval-value2" label-cols-sm="4" label-cols-lg="3" label="Interval Value 2" label-for="input-interval-value2" size="sm" :model.sync="model.intervalValue2"   />
				<app-input-textbox id="fieldset-interval-value3" label-cols-sm="4" label-cols-lg="3" label="Interval Value 3" label-for="input-interval-value3" size="sm" :model.sync="model.intervalValue3"   />
				<app-input-textbox id="fieldset-cron-expression" label-cols-sm="4" label-cols-lg="3" label="Cron Expression" label-for="input-cron-expression" size="sm" :model.sync="model.cronExpression"   />
				<app-input-combobox-autocomplete :options="jobConfigurations" optionsLabel="jobName" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Job Type" id="input-" size="sm" :model.sync="model.jobTypeId"  :selected="model.jobType != null ? model.jobType.jobName : ''" @input="getJobConfigurations" />
				<app-input-textbox id="fieldset-recurring-job-id" label-cols-sm="4" label-cols-lg="3" label="Recurring Job Id" label-for="input-recurring-job-id" size="sm" :model.sync="model.recurringJobId"   />
			</b-col>
			<b-col>
				<span class="float-right" v-if="modelId != null && modelId != undefined && modelId != ''">
					<b-button variant="success" class="float-right ml-2" @click="downloadData" size="sm"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
				</span>
			</b-col>
		</b-card>
		<PopupConfirmationDetail :openPopup="isShowPopupConfirmation" :model="model" @saveActionMethod="saveAction" @resetMethod="resetModal" />
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterView>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import SchedulerConfiguration from '@/models/SchedulerConfiguration/SchedulerConfiguration';
import SchedulerConfigurationList from '@/models/SchedulerConfiguration/SchedulerConfigurationList';
import SchedulerConfigurationFilter from '@/filters/SchedulerConfiguration/SchedulerConfigurationFilter';

import PopupConfirmationDetail from './PopupConfirmationDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import SchedulerCronInterval from '@/models/SchedulerCronInterval/SchedulerCronInterval';
import SchedulerCronIntervalFilter from '@/filters/SchedulerCronInterval/SchedulerCronIntervalFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import JobConfiguration from '@/models/JobConfiguration/JobConfiguration';
import JobConfigurationFilter from '@/filters/JobConfiguration/JobConfigurationFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {AppInputComboboxAutocomplete,AppInputTextbox,PopupRouterView,PopupConfirmationDetail},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterSchedulerConfiguration : null,
			currentSchedulerConfigurationPage : 1,
			schedulerConfigurationPageSize: 10,
			sortBySchedulerConfiguration: '',
			sortDescSchedulerConfiguration: '',
			schedulerCronIntervals: [],
			jobConfigurations: [],
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		getSchedulerConfiguration : async function(id) {
			this.isBusy = true;
			SchedulerConfiguration.getData(this, id).then(result => { this.model = result; this.mainRecordId = String(result.mainRecordId); this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadSchedulerConfiguration = true;
			this.filterSchedulerConfiguration.id = this.modelId;
			SchedulerConfiguration.downloadDataDetail(this, this.filterSchedulerConfiguration).then(result => {
				this.isDownloadSchedulerConfiguration = false;
			}).catch(error => { this.isDownloadSchedulerConfiguration = false; })
		},
		getSchedulerCronIntervals : async function(input) {
			let filter = new SchedulerCronIntervalFilter();
			if (input != undefined) {
				filter.name = input;
			}
			SchedulerCronInterval.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.schedulerCronIntervals = result.data
				}
			})
			.catch(error => {});
		},
		getJobConfigurations : async function(input) {
			let filter = new JobConfigurationFilter();
			if (input != undefined) {
				filter.jobName = input;
			}
			JobConfiguration.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.jobConfigurations = result.data
				}
			})
			.catch(error => {});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		saveActionConfirmation(modalEvent) {
			modalEvent.preventDefault();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isShowPopupConfirmation = true;
			}
		},
		saveAction(modalEvent) {
			this.isBusy = true;
			let id = this.modelId;
			let model = this.model;

			if (id != '' && id != null && id != undefined) {
				SchedulerConfiguration.updateData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$router.push({ name: 'schedulerconfigurationindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			} else {
				SchedulerConfiguration.insertData(this, model).then(result => {
					this.$router.push({ name: 'schedulerconfigurationindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		onHidden() {
			this.getSchedulerConfigurations();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterSchedulerConfiguration = new SchedulerConfigurationFilter();
		this.getSchedulerCronIntervals();
		this.getJobConfigurations();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getSchedulerConfiguration(id);
			} else {
				this.modelId = id;
				this.getSchedulerConfiguration(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
	},
	beforeDestroy() {
	},
}
</script>
